var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.$store.state.status.footerMsg.active)?_c('div',{staticClass:"footer-wrap"},[_c('p',{class:['msg-wrap',this.$store.state.status.footerMsg.type]},[_vm._v(" "+_vm._s(this.$store.state.status.footerMsg.text)+" ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }